<app-actions>
  <app-stroked-button (onClick)="onCreate($event)">Add New</app-stroked-button>
  <app-stroked-button
    *ngIf="showImport"
    appFilePicker
    (filesChanged)="onImport($event)"
  >Import from Excel</app-stroked-button>
  <app-button (onClick)="onSave($event)">Save</app-button>
</app-actions>
